import type { ConnectedService } from '../data/settings'
import type { ShareDestinationId } from '../types/integrations'

/**
 * Cross-posting rules. BEELYV is always the origin; external destinations are
 * opt-in per post and only exist for connected providers that support it.
 * Nothing is ever cross-posted by default.
 * REQUIRES BACKEND: real availability comes from the integration service.
 */
export const DEFAULT_SHARE_DESTINATIONS: ShareDestinationId[] = ['beelyv']

export function supportsCrossPost(service: ConnectedService): boolean {
  return service.capabilities.includes('crossPost')
}

export function canCrossPostTo(service: ConnectedService): boolean {
  return service.status === 'connected' && supportsCrossPost(service)
}
